import { format } from "date-fns";
import * as React from "react";

const BarChartWithTrendLineToolTip = (props: any) => {
    const color = props.color;
    return (
        <div style={{ width: "110px", backgroundColor: "#ffffff", position: "relative" }}>
         
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "baseline",
                }}
            >
                <div
                    style={{
                        height: "7px",
                        width: "7px",
                        backgroundColor: color,
                        borderRadius: "50%",
                    }}
                ></div>
                <div>
                    <h6 style={{ fontSize: 11, color: "#14191C" }}>Value: {props.value ? props.value : 0} </h6>
                </div>
            </div>
        
        </div>
    );
};

export default BarChartWithTrendLineToolTip;
